"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_linkify_1 = __importDefault(require("react-linkify"));
var utils_1 = require("../../../utils");
/**
 * A simple text element with optional markdown
 * @param {boolean} markdown Enable markdown parsing for the given text
 * @param {string} text The text to display
 * @param {boolean} escapeHTML Prevent unsafe HTML rendering when markdown is enabled
 * @param {number} maxLength Enables show more button when text overflows limit
 */
var Text = function (props) {
    var _a = (0, react_1.useState)(false), showMore = _a[0], setShowMore = _a[1];
    var maxLength = props.maxLength, markdown = props.markdown, escapeHTML = props.escapeHTML, intl = props.intl, text = props.text;
    var hasShowMore;
    if (intl && maxLength && text.length > maxLength) {
        hasShowMore = true;
    }
    var rtl = utils_1.isRTLText.test(text);
    return (react_1.default.createElement(react_linkify_1.default, { properties: { target: '_blank' } },
        react_1.default.createElement("div", { className: (0, classnames_1.default)({ rtl: rtl }) },
            react_1.default.createElement(utils_1.ProcessedText, { isBotMessage: props.isBotMessage, intl: intl, maxLength: maxLength, escapeHTML: escapeHTML, markdown: markdown, showMore: showMore }, text)),
        hasShowMore && (react_1.default.createElement("button", { type: "button", onClick: function (e) { return setShowMore(!showMore); }, className: "bpw-message-read-more" },
            showMore &&
                intl.formatMessage({
                    id: 'messages.showLess',
                    defaultMessage: 'Show Less'
                }),
            !showMore &&
                intl.formatMessage({
                    id: 'messages.readMore',
                    defaultMessage: 'Read More'
                })))));
};
exports.Text = Text;
exports.default = exports.Text;
